import { type RouteConfig } from 'vue-router'

export const OrphanedRouter: RouteConfig[] = [
  {
    path: '/orphaned',
    component: async () => import('./Orphaned.vue'),
  },
]
